type PrizeItem = {
  id: string | number;
  prizeType?: number;
  prizeName?: string;
  prizeImage?: string | FileList | any;
  winLimit?: number;
  totalStock: number | string;
  winProbability: number | string;
};

type PrizePool = {
  id?: string | number;
  prizePoolName?: string;
  gashaponNum?: number;
  prizeList: PrizeItem[];
};

type PrizePoolList = PrizePool[];

export const isPrizePoolChanged = (
  current: PrizePoolList,
  original: PrizePoolList
): boolean => {
  if (current.length !== original.length) return true;
  for (let i = 0; i < current.length; i++) {
    const curPool = current[i];
    const oriPool = original[i];
    // 比对奖池名或 gashaponNum
    if (
      (curPool.prizePoolName || '') !== (oriPool.prizePoolName || '') ||
      Number(curPool.gashaponNum ?? 0) !== Number(oriPool.gashaponNum ?? 0)
    ) {
      return true;
    }
    const curList = curPool.prizeList || [];
    const oriList = oriPool.prizeList || [];
    if (curList.length !== oriList.length) return true;
    for (let j = 0; j < curList.length; j++) {
      const cur = curList[j];
      const ori = oriList[j];
      if ((cur.id || '') !== (ori.id || '')) return true;
      const fieldsToCompare = [
        'totalStock',
        'winProbability',
        'winLimit',
        'prizeType',
        'prizeName',
      ];
      for (const key of fieldsToCompare) {
        const curVal = cur[key];
        const oriVal = ori[key];
        const isNumber =
          typeof curVal === 'number' || typeof oriVal === 'number';
        if (isNumber) {
          const keyIsProbability = key === 'winProbability';
          const precision = keyIsProbability ? 1e-5 : 1e-3;
          if (Math.abs(Number(curVal ?? 0) - Number(oriVal ?? 0)) > precision) {
            return true;
          }
        } else {
          if ((curVal ?? '') !== (oriVal ?? '')) {
            return true;
          }
        }
      }
      // 特殊处理 prizeImage（支持 URL 或文件上传结构）
      const getImageUrl = (img: any) =>
        typeof img === 'string'
          ? img
          : img?.[0]?.response?.url || img?.[0]?.url || '';
      const curImg = getImageUrl(cur.prizeImage);
      const oriImg = getImageUrl(ori.prizeImage);
      if ((curImg || '') !== (oriImg || '')) {
        return true;
      }
    }
  }
  return false;
};
